
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { receivedList, generateOrder, releasePurchase, mark } from '@/api/pcm/purchase';
import { Message } from 'element-ui';

export default extend(table, {
    namespaced: true,
    state: {
        searchForm: {}
    },
    actions: {
        async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'pcm.purdemand.list', async function() {
                const { searchForm } = state;
				await dispatch('getData', {
					caller: receivedList,
					options: {
						...searchForm,
						...payload
					}
				});
            })
        },
        async generateOrder({ state, dispatch }, {multipleSelection, depotId}) {
            if (multipleSelection.length <= 0) {
                return Message.error('至少勾选一个采购需求');
            }
            await wait(dispatch, 'pcm.purdemand.generate', async function() {
                await generateOrder({
                    purDemandRecIds: multipleSelection.map((v) => {
                        return v.recId;
                    }),
					depotId: depotId
                });
                Message.success('操作成功');
            })
            dispatch('getList')
        },
        async releasePurchase({ state, dispatch }, multipleSelection) {
            if (multipleSelection.length <= 0) {
                return Message.error('至少勾选一个采购需求');
            }
            await wait(dispatch, 'pcm.purdemand.release', async function() {
                await releasePurchase({
                    purDemandRecIds: multipleSelection.map((v) => {
                        return v.recId;
                    })
                });
                Message.success('操作成功');
            })
            dispatch('getList')
        },
        async markPurchaseAction({ state, dispatch }, payload) {
            await wait(dispatch, 'pcm.purdemand.mark', async function() {
                await mark(payload);
                Message.success('操作成功');
            })
            dispatch('getList')
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/purdemand/list.js